import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  private _common = `${environment.common}`;

  constructor(
    private _http: HttpClient,
    private _router: Router
  ) { }

  getLovColumnData(entityName: any, columnName: any) : Observable<any>{    
    return this._http.get<any>(`${this._common}/GetLovColumnData?entityName=${entityName}&columnName=${columnName}`);
  }

  
}
